// extracted by mini-css-extract-plugin
export default {"widgetCardsWrapper":"SpiTrend_widgetCardsWrapper__kbWW+","chart":"SpiTrend_chart__reVo9"};